<div
  #input
  #origin="ttAutocompleteOrigin"
  class="tag-grid"
  role="presentation"
  ttAutocompleteOrigin
  ttInput
  [attr.data-testid]="testId"
  [error]="_error()">
  <div cdkDropList cdkDropListOrientation="mixed" class="tag-grid-option-list" (cdkDropListDropped)="handleElementDropped($event)">
    @for (option of _selectedLabelOptions(); track option) {
      <span
        cdkDrag
        class="tag-grid-option"
        [attr.data-testid]="'tag-grid_tag-' + option.label.split(' ').join('-')"
        [cdkDragDisabled]="_disabled()">
        @if (selectedTemplate) {
          <ng-container *ngTemplateOutlet="selectedTemplate; context: { $implicit: option }" />
        } @else {
          <span>{{ option.label }}</span>
        }
        @if (!_disabled()) {
          <button type="button" (click)="removeTag(option.value, $event)">
            <mat-icon data-testid="tag-grid_remove-button" [icon]="'x'" [iconSize]="14" />
          </button>
        }
      </span>
    }
    <input
      aria-haspopup="listbox"
      type="text"
      [formControl]="searchControl"
      [placeholder]="_placeholder()"
      [ttAutocomplete]="auto"
      [ttAutocompleteConnectedTo]="origin"
      (focus)="onInputFocus()"
      (keydown)="handleKeyDown($event)"
      (optionSelected)="handleOptionSelect($event)" />
  </div>
</div>

<tt-autocomplete #auto="ttAutocomplete">
  @for (option of filteredPossibleOptions(); track option.value) {
    <li aria-label="{{ option.label }}" aria-selected="false" role="option" ttItem [value]="option.value">
      @if (optionTemplate) {
        <ng-container *ngTemplateOutlet="optionTemplate; context: { $implicit: option }" />
      } @else {
        <span>{{ option.label }}</span>
      }
    </li>
  }
</tt-autocomplete>
